









































































import { Component, Vue } from 'vue-property-decorator';
import { makeToast } from '@/modules/budget-request/components/js/some-functions';
import {
    dateFormat, sortByField, userUiid, trMsg, MSG_BIP, MSG_CDF, MSG_SMS
} from "@/modules/budget/bip/bip-types";
import * as CryptoJS from "crypto-js";
import NCAlayerService from "@/services/ncalayer";
import store from "@/services/store";

@Component({
    name: 'c-sign-log-modal'
})
export default class CBudgetSignLogModal extends Vue {

    private MSG_BIP = MSG_BIP;
    private MSG_CDF = MSG_CDF;

    private sign: any;
    private params: any = {};

    private showModal = false;

    private comment = '';
    private signer = [];
    private logLst: any[] = [];

    get userIin(): string | null {
        // return 'abab80c6-525b-4151-9499-a1ff21a157d2'; // ----- временнно!!!!!!!!
        if (!store.state.user.preferred_username) { return null; }
        return store.state.user.preferred_username;
    }

    private showEvent(sign: any, params: any) {
        this.sign = sign;
        this.params = params;

        this.logLst = [];
        sign['logList'].forEach((row: any) => {
            this.$set(row, 'signers', sign.signers);
        });
        let log = sign['logList'];

        if (['bip'].includes(params.mode)) {
            sign.uebp.logList.forEach((row: any) => {
                this.$set(row, 'signers', sign.uebp.signers);
            });
            log = log.concat(sign.uebp.logList)
        }
        if (['uebp'].includes(params.mode)) {
            sign.form.logList.forEach((row: any) => {
                this.$set(row, 'signers', sign.form.signers);
            });
            log = log.concat(sign.form.logList)
        }

        log.forEach((sign: any) => {
            const signer  = sign.signers.filter((row:any) => row.id_user === sign.user_id);
            this.$set(sign, 'signer', signer.length > 0 ? signer[0] : undefined)
            if (sign.deleted) {
                const item = {
                    'deleted': false,
                    'name': (sign.signer ? sign.signer.name : this.trMsg(MSG_CDF + 'signer_deleted')),
                    'sign_date': sign.sign_date,
                    'comment': '',
                    'source': (sign.source ? sign.source : '')
                };
                const item1 = {
                    'deleted': sign.deleted,
                    'name': (sign.signer ? sign.signer.name : this.trMsg(MSG_CDF + 'signer_deleted')),
                    'sign_date': sign.del_date,
                    'comment': (sign.comment === null ? '' : sign.comment),
                    'source': (sign.source ? sign.source : '')
                };
                this.logLst.push(item);
                this.logLst.push(item1);
            } else {
                this.logLst.push({
                    'deleted': sign.deleted,
                    'name': (sign.signer ? sign.signer.name : this.trMsg(MSG_CDF + 'signer_deleted')),
                    'sign_date': sign.sign_date,
                    'comment': '',
                    'source': (sign.source ? sign.source : '')
                });
            }
        })

        this.logLst.sort(sortByField('sign_date'));
        this.logLst.forEach((sign: any) => {
            sign.sign_date = dateFormat(this, new Date(sign.sign_date))
        })
        this.signer = sign.signers.filter((row: any) => row.id_user === userUiid);
        this.showModal = true;
    }

    private async startSign() {
        if (!this.userIin || this.userIin.length < 3) {
            makeToast(this, 'warning', this.trMsg(MSG_CDF + 'signature'),
                this.trMsg(MSG_CDF + 'user_IIN_unable'));
            return;
        }

        const data = {
            variant: this.params.version.variant_uuid,
            abp: this.params.abp.abp,
            cur_year: this.params.version.year,
            data_type: this.params.version.data_type,
            region: this.params.version.region_code,
            user_id: userUiid,
            val1: this.sign.plan1,
            val2: this.sign.plan2,
            val3: this.sign.plan3
        }

        const signers = this.sign.signers
            .map((row: any) => {
            // Определяем статус удаления и подпись
            const sign = row.log?.find((item: any) => !item.deleted);
            const hasValidSign = !!sign;
            const deleted = !hasValidSign;
            if (!deleted) return row.id_user;
        });
        const qrData = {
            variant: this.params.version.variant_uuid,
            abp: this.params.abp.abp,
            signers: signers.toString()
        }

        let response = null;
        try {
            const hash: string = CryptoJS.SHA256(JSON.stringify(data)).toString();
            const qrHash: string = CryptoJS.SHA256(JSON.stringify(qrData)).toString();

            response = await NCAlayerService.signData(hash,
                { iin: (this.userIin !== null ? this.userIin.slice(3) : '') });

            this.$set(data, 'hash', hash)
            this.$set(data, 'qrHash', qrHash)
            this.$set(data, 'sign', response.result)

            if (response.error) {
                makeToast(this, 'danger', this.trMsg(MSG_SMS + 'error_sign'), response.error);
                return
            }
        } catch (error) {
            makeToast(this, 'danger', this.trMsg(MSG_SMS + 'error_sign'),
                (error as Error).toString());
            return
        }

        if (!response.result) { return }

        try {
            if (['bp'].includes(this.params.mode)) {

                let result: any = await fetch('/api-py/sign-cost-data',
                    {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(data)
                    });
                if (result.status === 200) {
                    result = await result.json();

                    if (result.result === 'success') {
                        makeToast(this, 'success', this.trMsg(MSG_CDF + 'signature'),
                            this.trMsg(MSG_CDF + 'data_signed'));
                        this.showModal = false;
                        this.$emit("updateSign", true);
                    } else {
                        makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'), result.txt);
                    }
                } else {
                    makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'),
                        this.trMsg(MSG_SMS + 'error_sign') + ` ${result.status} ${result.statusText}`);
                    return
                }
            }

            if (['bip'].includes(this.params.mode)) {
                this.$set(data, 'source', 'form');

                let result: any = await fetch('/api-py/sign-bip-data',
                    {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(data)
                    });
                if (result.status === 200) {
                    result = await result.json();

                    if (result.result === 'success') {
                        makeToast(this, 'success', this.trMsg(MSG_CDF + 'signature'),
                            this.trMsg(MSG_CDF + 'data_signed'));
                        this.showModal = false;
                        this.$emit("updateSign", true);
                    } else {
                        makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'), result.txt);
                    }
                } else {
                    makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'),
                        this.trMsg(MSG_SMS + 'error_sign') + ` ${result.status} ${result.statusText}`);
                    return
                }
            }

            if (['uebp'].includes(this.params.mode)) {
                this.$set(data, 'source', 'uebp');

                let result: any = await fetch('/api-py/sign-bip-data',
                    {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(data)
                    });
                if (result.status === 200) {
                    result = await result.json();

                    if (result.result === 'success') {
                        makeToast(this, 'success', this.trMsg(MSG_CDF + 'signature'),
                            this.trMsg(MSG_CDF + 'data_signed'));
                        this.showModal = false;
                        this.$emit("updateSign", true);
                    } else {
                        makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'), result.txt);
                    }
                } else {
                    makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'),
                        this.trMsg(MSG_SMS + 'error_sign') + ` ${result.status} ${result.statusText}`);
                    return
                }
            }
        } catch (error) {
            makeToast(this, 'danger', this.trMsg(MSG_SMS + 'error_sign'),
                (error as Error).toString());
            return
        } finally {

        }
    }

    private async revokeSign() {

        const params = {
            variant: this.params.version.variant_uuid,
            abp: this.params.abp.abp,
            comment: this.comment,
            user_id: userUiid,
            auto: false
        };

        const signers = this.sign.signers
            .map((row: any) => {
                // Определяем статус удаления и подпись
                const sign = row.log?.find((item: any) => !item.deleted);
                const hasValidSign = !!sign;
                const deleted = !hasValidSign;
                if (!deleted && row.id_user !== userUiid) return row.id_user;
            });
        const qrData = {
            variant: this.params.version.variant_uuid,
            abp: this.params.abp.abp,
            signers: signers.toString()
        }

        const qrHash: string = CryptoJS.SHA256(JSON.stringify(qrData)).toString();
        this.$set(params, 'qrHash', qrHash)

        if (['bp'].includes(this.params.mode)) {
            let result: any = await fetch('/api-py/revoke-cost-data',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify(params)
                });
            if (result.status === 200) {
                result = await result.json();

                if (result.result === 'success') {
                    makeToast(this, 'success', this.trMsg(MSG_CDF + 'revoke_sign'),
                        this.trMsg(MSG_CDF + 'sign_revoked'));
                    this.showModal = false;
                    this.$emit("updateSign", true);
                } else {
                    makeToast(this, 'danger', this.trMsg(MSG_CDF + 'revoke_sign'), result.txt);
                }
            } else {
                makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'),
                    this.trMsg(MSG_SMS + 'error_sign') + ` ${result.status} ${result.statusText}`);
                return;
            }
        }

        if (['bip'].includes(this.params.mode)) {
            this.$set(params, 'source', 'form');

            let result: any = await fetch('/api-py/revoke-bip-data',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify(params)
                });
            if (result.status === 200) {
                result = await result.json();

                if (result.result === 'success') {
                    makeToast(this, 'success', this.trMsg(MSG_CDF + 'revoke_sign'),
                        this.trMsg(MSG_CDF + 'sign_revoked'));
                    this.showModal = false;
                    this.$emit("updateSign", true);
                } else {
                    makeToast(this, 'danger', this.trMsg(MSG_CDF + 'revoke_sign'), result.txt);
                }
            } else {
                makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'),
                    this.trMsg(MSG_SMS + 'error_sign') + ` ${result.status} ${result.statusText}`);
                return;
            }
        }

        if (['uebp'].includes(this.params.mode)) {
            this.$set(params, 'source', 'uebp');

            let result: any = await fetch('/api-py/revoke-bip-data',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify(params)
                });
            if (result.status === 200) {
                result = await result.json();

                if (result.result === 'success') {
                    makeToast(this, 'success', this.trMsg(MSG_CDF + 'revoke_sign'),
                        this.trMsg(MSG_CDF + 'sign_revoked'));
                    this.showModal = false;
                    this.$emit("updateSign", true);
                } else {
                    makeToast(this, 'danger', this.trMsg(MSG_CDF + 'revoke_sign'), result.txt);
                }
            } else {
                makeToast(this, 'danger', this.trMsg(MSG_CDF + 'signature'),
                    this.trMsg(MSG_SMS + 'error_sign') + ` ${result.status} ${result.statusText}`);
                return;
            }
        }

        this.comment = '';
        this.showModal = false;
    }

    // translate messages
    private trMsg(field: string) {
        return trMsg(this, field);
    }
}
